/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Dev_Testing_BodyInputs */

const en_marketing_dev_testing_body = /** @type {(inputs: Marketing_Dev_Testing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playwright covers the real journeys, Vitest covers the units, and CI enforces types, tests, and bundle-size budgets on every push.`)
};

const es_marketing_dev_testing_body = /** @type {(inputs: Marketing_Dev_Testing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playwright cubre los recorridos reales, Vitest cubre las unidades y CI aplica los tipos, las pruebas y los presupuestos de tamaño del paquete en cada push.`)
};

const fr_marketing_dev_testing_body = /** @type {(inputs: Marketing_Dev_Testing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playwright couvre les parcours réels, Vitest couvre les unités, et la CI impose les types, les tests et les budgets de taille de bundle à chaque push.`)
};

/**
* | output |
* | --- |
* | "Playwright covers the real journeys, Vitest covers the units, and CI enforces types, tests, and bundle-size budgets on every push." |
*
* @param {Marketing_Dev_Testing_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_dev_testing_body = /** @type {((inputs?: Marketing_Dev_Testing_BodyInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Dev_Testing_BodyInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_dev_testing_body(inputs)
	if (locale === "es") return es_marketing_dev_testing_body(inputs)
	return fr_marketing_dev_testing_body(inputs)
});